import * as React from "react";
import { StandardProps } from "@material-ui/core";
import { ButtonBaseProps } from "@material-ui/core/ButtonBase";
import MuiListItem, { ListItemClassKey as MuiListItemClassKey } from "@material-ui/core/ListItem";


export type ListItemClassKey = MuiListItemClassKey;

export interface ListItemProps extends StandardProps<ButtonBaseProps & React.LiHTMLAttributes<HTMLElement>, ListItemClassKey, 'component'> {
    button?: boolean;
    component?: React.ReactType<ListItemProps>;
    ContainerComponent?: React.ReactType<React.HTMLAttributes<HTMLDivElement>>;
    ContainerProps?: React.HTMLAttributes<HTMLDivElement>;
    dense?: boolean;
    disabled?: boolean;
    disableGutters?: boolean;
    divider?: boolean;
    focusVisibleClassName?: string;
    selected?: boolean;
}

class ListItem extends React.PureComponent<ListItemProps> {
    render() {
        const { ...props } = this.props;
        return <MuiListItem {...props}>
            {this.props.children}
        </MuiListItem>;
    }
}

export default ListItem;